import { session } from "~/clientInstance";
import type { ShouldSampleSpan } from "~/openTelemetry/SpanFilteringExporter";

export const onlyWhenAuthenticatedFilter: ShouldSampleSpan = () => {
    return session.isAuthenticated(); // We currently only track telemetry for authenticated users
};
